<template>
  <dv-border-box-10 :reverse="true">
    <div class="map-wrapper">
      <div :id="mapId" class="base-map"></div>
    </div>
  </dv-border-box-10>
</template>

<script>
import { mapState } from "vuex";
import { map_theme } from "./options";
import { GetQueryString } from "@/utils/commonUtils";
import { getBoundary, drawBoundary } from "@/utils/mapUtils";
export default {
  data() {
    return {
      map: null
    };
  },
  computed: {},
  mounted() {
    this.initMap();
  },
  props: [
    "height",
    "width",
    "mapId",
    "show_map_type",
    "mapTheme",
    "authUserInfo",
    "zoom",
    "viewport",
    "showHYBRID_MAP"
  ],
  watch: {
    showHYBRID_MAP() {
      if (this.showHYBRID_MAP) {
        this.map.setMapType(BMAP_HYBRID_MAP);
      } else {
        this.map.setMapType(BMAP_NORMAL_MAP);
      }
    }
  },
  methods: {
    initMap() {
      if (!this.authUserInfo) {
        return;
      }
      var zoom = this.zoom || 11;
      let city = "北京";
      if (this.authUserInfo.city) {
        city = this.authUserInfo.city;
      }
      var map = new BMap.Map(this.mapId, { enableMapClick: false }); // 创建Map实例
      this.map = map;
      window.map = map;
      drawBoundary(map, city);
      map.centerAndZoom(new BMap.Point(116.404844, 39.916927), zoom);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      map.enableDragging();
      map.setMapStyle(map_theme);
      window.$Map = map;
      this.$emit("map", map);
    }
  }
};
</script>
<style lang="less">
.wrapper {
  width: 100%;
  height: 100%;
  // padding: 20px;
}
#wrapper-border {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
}

.map-wrapper {
  width: 100%;
  height: 100%;
  padding-top: 1.5%;
  padding-left: 1.5%;
}
.base-map {
  // z-index: 100;
  height: 98.5%;
  width: 98.5%;
  vertical-align: middle;
  // margin: 2.5% auto;
}
</style>
